import React, { useState } from "react";
import { ITableModel } from "../interface";
import DeleteIcon from "img/delete.svg";
import { TablePortal } from "components/TablePortal";
import Input from "components/Input";

const SkusTable: React.FC<any> = (props) => {
  const handleChangeSelectItems = (item: any) => {
    if (props.onToggleSelectItem) {
      props.onToggleSelectItem(item.id);
    }
  };

  const handleOpenModalConfirmExclusion = (id: string) => {
    if (props.openModalConfirmExclusion) {
      props.openModalConfirmExclusion(true);
    }
    if (props.setSelectedIdToDelete) {
      props.setSelectedIdToDelete(id);
    }
  };

  const [tableOrder, setTableOrder] = useState("quotationDate desc");
  const pageTotal = props.pageSize || 10;
  const quoteModelComplete: Array<ITableModel> = [
    {
      label: "",
      key: "check",
      size: 50,
      maxSize: 50,
      Component: (item: any) => (
        <Input
          type="checkbox"
          id={item.code}
          value={item.id}
          onClick={() => handleChangeSelectItems(item)}
          defaultChecked={props.selectedItems.includes(item.id)}
        />
      ),
    },
    { label: "Código", key: "ean", size: 150, maxSize: 150, noFilter: true },
    {
      label: "Descrição",
      key: "supplierProductDescription",
      size: 180,
      maxSize: 330,
      noFilter: true,
    },
    {
      label: "Substância",
      key: "molecule",
      size: 180,
      maxSize: 330,
      noFilter: true,
    },
    {
      label: "Marca",
      size: 150,
      maxSize: 205,
      key: "supplier",
      noFilter: true,
    },
    {
      label: "Categoria",
      key: "classification",
      size: 150,
      maxSize: 205,
      noFilter: true,
    },
    {
      label: "Excluir",
      noFilter: true,
      size: 90,
      maxSize: 90,
      Component: (item: any) => (
        <img
          src={DeleteIcon}
          alt="Icon"
          className="cursor-pointer"
          onClick={() => handleOpenModalConfirmExclusion(item.id)}
        />
      ),
    },
  ];

  return (
    <TablePortal
      trackingKey="code"
      data={props.data}
      className="mt-3"
      onReload={props.onReload}
      error={props.error}
      currentPage={props.currentPage}
      tableOrder={tableOrder}
      setTableOrder={setTableOrder}
      totalPages={props.totalPages}
      pageSize={pageTotal}
      onPageChange={props.setCurrentPage}
      model={props.model || quoteModelComplete}
      completeBlankSpaces={false}
    />
  );
};

export default SkusTable;